import type { LocationQueryValue, RouteLocationNormalizedLoaded } from 'vue-router';

export function isRouteParamTrue(value: LocationQueryValue | LocationQueryValue[] | undefined): boolean {
	return value === 'true' || value === '1' || (Array.isArray(value) && isRouteParamTrue(value[0]));
}

/**
 * Whether `route` is, or is nested under, the record named `name`.
 *
 * Checks `route.matched`, not `route.name`: the route a parent page receives on a direct load
 * carries the matched records but no `name` until the next client-side navigation.
 */
export function isRouteWithin(route: RouteLocationNormalizedLoaded, name: string): boolean {
	return route.matched.some((record) => record.name === name);
}

/**
 * Narrow `route.query.X` to its first string value. `route.query` entries are
 * `string | null | (string | null)[]` because URLs like `?reason=a&reason=b`
 * produce arrays — the inline `as string` casts that show up everywhere are
 * unsound for those cases.
 */
export function firstString(
	value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | undefined {
	const candidate = Array.isArray(value) ? value[0] : value;
	return typeof candidate === 'string' ? candidate : undefined;
}
